import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Header from './Header';
import Sidebar from './Sidebar';
import { useUI } from '../../contexts/UIContext';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f9fafb;
`;

const MainContent = styled.main<{ $isCollapsed: boolean }>`
  flex: 1;
  margin-left: ${props => props.$isCollapsed ? '64px' : '256px'};
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s ease;
`;

const ContentArea = styled.div<{ $hasHeader: boolean }>`
  flex: 1;
  padding: 24px;
  margin-top: ${props => props.$hasHeader ? '5px' : '0'};
  overflow-y: auto;
`;

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isSidebarCollapsed, isIframeMode } = useUI();

  return (
    <LayoutContainer>
      <Sidebar />
      <MainContent $isCollapsed={isSidebarCollapsed}>
        {/* Hide header in iframe mode */}
        {!isIframeMode && <Header />}
        <ContentArea $hasHeader={!isIframeMode}>
          {children}
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;